
import { Component, Prop, Vue } from "vue-property-decorator";
import PokemonModule from "@/store/Pokemon";
import EachPokemon from "@/components/EachPokemon.vue";
@Component({
  components: {
    EachPokemon,
  },
})
export default class InfiniteScroll extends Vue {
  @Prop({ required: true }) articles!: [
    {
      name: string;
      url: string;
      sprites: { other: { dream_world: { front_default: string } } };
    }
  ];
  isActive = false;
  offset = 0;
  // limit = 100;
  async handleScrollToBottom(isVisible: boolean) {
    if (!isVisible) {
      return;
    }
    this.offset += 100;
    this.$emit("refetch", this.offset);
  }
}
